import { type AccountSummary, type HolisticCategory } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

export interface CreateManualAccountBody {
    userId: string;
    membershipId: string;
    name: string;
    amount: number;
    description: string;
    interestRate?: number;
    minimumPayment?: number;
    holisticCategory: HolisticCategory;
    institutionName: string;
}

const useCreateManualAccount = requestBuilder.mutation<
    AccountSummary,
    CreateManualAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/manual',
    method: 'POST',
});

export const useCreateManualAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useCreateManualAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const createManualAccountAsync = async (body: CreateManualAccountBody) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        createManualAccountAsync,
    };
};
